import { eNotify } from './eNotify';
import { pdfHeader } from './pdf';
import { vipHeader } from './vip';
import { letterHeader } from './letter';
import { twidHeader } from './twid';
// 無天版
export default [...eNotify, ...pdfHeader, ...vipHeader, ...letterHeader, ...twidHeader];
